import { Divider, Box, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { RoomItemProps } from '../../interfaces/components';
import { SpaceNext } from '../../Icons/SpaceNext';

function RoomItem({
  activeLocale,
  alignRight,
  divider = true,
  rightIcon = true,
  icon,
  itemText,
  onClick,
}: RoomItemProps) {
  const [hovered, setHovered] = useState(false);

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" w="100%">
      {icon}
      <Box
        w="150px"
        onClick={onClick}
        cursor="pointer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Box display="flex" justifyContent={alignRight ? 'flex-start' : 'space-between'} alignItems="center">
          <Text
            fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
            fontWeight="600"
            color={hovered ? 'rgb(0,0,0,0.6)' : 'black'}
            fontSize={['13px', '14px', '15px', '15px', '15px']}
            transition=".5s"
          >
            {itemText}
          </Text>
          {rightIcon && (
            <SpaceNext
              visibility={hovered ? 'visible' : 'hidden'}
              transition=".5s"
              opacity={hovered ? '1' : '0'}
              boxSize={[3, 3, 4]}
            />
          )}
        </Box>

        {divider && <Divider borderWidth="1px" borderColor={hovered ? 'rgb(0,0,0,0.6)' : 'black'} transition=".5s" />}
      </Box>
    </Box>
  );
}

export default RoomItem;
